<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="流向" name="liuxiang"> </el-tab-pane>
      <el-tab-pane label="汇总" name="huizong"> </el-tab-pane>
    </el-tabs>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini" :model="searchForm">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="queryTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="车辆所属:">
          <el-select v-model="searchForm.ownership" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="自有车" :value="0"></el-option>
            <el-option label="市场车" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称:">
           <el-input size="mini" v-model.trim="searchForm.payee" placeholder=""></el-input>
        </el-form-item>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row center border :span-method="objectSpanMethod" :cell-style="setCellStyle" >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="payee" width="260" label="客户名称"></el-table-column>
          <el-table-column prop="startDirection" v-if="activeName=='liuxiang'" min-width="120" label="始发流向" show-overflow-tooltip :formatter="formatEmpty"></el-table-column>
          <el-table-column prop="endDirection" v-if="activeName=='liuxiang'" min-width="120" label="目的流向" show-overflow-tooltip :formatter="formatEmpty"></el-table-column>
        <el-table-column prop="productTypeName" min-width="" label="货物类型" show-overflow-tooltip :formatter="formatEmpty"></el-table-column>
        <el-table-column prop="ydzs" min-width="" label="运单总数" :formatter="formatEmpty"></el-table-column>
        <el-table-column prop="liquidatedAmount" min-width="80" label="业务量" :formatter="formatEmpty"></el-table-column>
        <el-table-column prop="grossRevenue" min-width="" label="不含税收入" :formatter="formatEmpty"></el-table-column>
        <el-table-column prop="freightAmountTotal" min-width="" label="不含税支出" :formatter="formatEmpty"></el-table-column>
        <el-table-column prop="ml" min-width="" label="毛利" :formatter="formatEmpty"></el-table-column>
        <el-table-column prop="mll" min-width="" label="毛利率" :formatter="formatEmpty">
          <template slot-scope="scope">
            <span>{{ scope.row.mll }}{{ scope.row._isSummary ? '' : '%' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
import { findBaseWarehouseCustomerList, findBaseWarehouseCustomerAllList } from '@/api/newTMS'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'ChelianglayunzhanbiDetail',
  data () {
    return {
      activeName: 'liuxiang',
      queryTime: [],
      isFromAnalysis: false,
      searchForm: {
        startTime: '',
        endTime: '',
        ownership: ''
      },
      tableList: [],
      spanArr: {
        payee: [],
        startDirection: [],
        endDirection: []
      },
      h: '',
      isDaoChu: false
    }
  },
  watch: {
    '$route.fullPath' () {
      this.initPageParams()
      this.getList()
    }
  },
  created () {
    if (this.$route.query.source) {
      this.activeName = 'huizong'
    }
    this.initPageParams()
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 180 + 'px'
  },
  methods: {
    handleTabClick () {
      this.getList()
    },
    getLastMonthRange () {
      const end = new Date()
      // 设置结束时间为当天的 23:59:59
      const start = new Date(end)
      const currentDay = start.getDate()
      start.setDate(1)
      start.setMonth(start.getMonth() - 1)
      const lastDayOfLastMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate()
      start.setDate(Math.min(currentDay, lastDayOfLastMonth))
      // 设置开始时间为当天的 00:00:00
      return {
        startTime: this.formatDateTime(start),
        endTime: this.formatDateTime(end)
      }
    },
    // 格式化时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    initQueryTime () {
      const { startTime, endTime } = this.getLastMonthRange()
      this.queryTime = [startTime, endTime]
    },
    initPageParams () {
      const { source = '', startTime = '', endTime = '', ownership = '' } = this.$route.query
      this.isFromAnalysis = source === 'chelianglayunzhanbi'
      if (this.isFromAnalysis && startTime && endTime) {
        this.queryTime = [startTime, endTime]
        this.searchForm = {
          startTime: startTime,
          endTime: endTime,
          ownership: ownership === '0' || ownership === 0 ? 0 : (ownership === '1' || ownership === 1 ? 1 : '')
        }
        return
      }
      this.initQueryTime()
      this.searchForm = {
        startTime: this.queryTime[0],
        endTime: this.queryTime[1],
        ownership: ''
      }
    },
    searchFn () {
      this.getList()
    },
    resetForm () {
      this.initPageParams()
      this.getList()
    },
    // 设置单元格样式
    setCellStyle ({ row, column, rowIndex, columnIndex }) {
      // 判断 teamName 是否为"合计"
      if (row.payee === '小计') {
        // 如果是序号列，将内容设为空字符串
        if (column.type === 'index') {
          return {
            color: '',
            fontWeight: '',
            '&::before': {
              content: '""' // 伪元素方式清空内容
            }
          }
        }
        return {
          color: '#1890ff',
          fontWeight: 'bold'
        }
      }
      return null
    },
    getList () {
      if (!this.queryTime || this.queryTime.length !== 2) {
        this.$message.error('请先选择时间范围')
        return
      }
      this.searchForm.startTime = this.queryTime[0]
      this.searchForm.endTime = this.queryTime[1]
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      if (this.activeName == 'liuxiang') {
        findBaseWarehouseCustomerList(this.searchForm)
          .then(res => {
            this.tableList = Array.isArray(res) ? res : (res && Array.isArray(res.list) ? res.list : [])
            let json = {
              payee: '小计',
              _isSummary: true,
              grossRevenue: res.allArossRevenue,
              ydzs: res.allYdzs,
              ml: res.allMl,
              mll: res.allMll,
              liquidatedAmount: res.allLiquidatedAmount,
              freightAmountTotal: res.allFreightAmountTotal,
              residualWeight: res.allResidualWeight
            }
            this.tableList.push(json)
            this.getSpanArr(this.tableList)
            loading.close()
          })
          .catch(err => {
            loading.close()
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error'
            })
          })
      } else {
        findBaseWarehouseCustomerAllList(this.searchForm)
          .then(res => {
            this.tableList = Array.isArray(res) ? res : (res && Array.isArray(res.list) ? res.list : [])
            let json = {
              payee: '小计',
              _isSummary: true,
              grossRevenue: res.allArossRevenue,
              ydzs: res.allYdzs,
              ml: res.allMl,
              mll: res.allMll,
              liquidatedAmount: res.allLiquidatedAmount,
              freightAmountTotal: res.allFreightAmountTotal,
              residualWeight: res.allResidualWeight
            }
            this.tableList.push(json)
            this.getSpanArr(this.tableList)
            loading.close()
          })
          .catch(err => {
            loading.close()
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error'
            })
          })
      }
    },
    formatEmpty (row, column, cellValue) {
      return cellValue === null || cellValue === undefined || cellValue === '' ? '-' : cellValue
    },
    // 生成合并规则数组
    getSpanArr (data) {
      this.spanArr = {
        payee: this.createSpanArr(data, ['payee'])
        // startDirection: this.createSpanArr(data, ['startDirection']),
        // endDirection: this.createSpanArr(data, ['endDirection'])
      }
    },
    createSpanArr (data, fields) {
      const spanArr = []
      let pos = 0
      data.forEach((item, index) => {
        if (index === 0) {
          spanArr.push(1)
          pos = 0
        } else {
          const isSame = fields.every(field => item[field] === data[index - 1][field])
          if (isSame) {
            spanArr[pos] += 1
            spanArr.push(0) // 0表示该行被合并
          } else {
            spanArr.push(1)
            pos = index
          }
        }
      })
      return spanArr
    },
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      const currentSpanArr = this.spanArr[column.property]
      if (currentSpanArr) {
        const _row = currentSpanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      } else {
        return [1, 1]
      }
    },
    // 导出
    exportFn () {
      let form = { ...this.searchForm }
      if (this.activeName == 'liuxiang') {
        exportExcel(
          this.global.tmsPlus + '/reportw/findBaseWarehouseCustomerExcel',
          form,
          '基地仓客户明细'
        )
      } else {
        exportExcel(
          this.global.tmsPlus + '/reportw/findBaseWarehouseCustomerAllExcel',
          form,
          '基地仓客户明细'
        )
      }

      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>
<style scoped lang="less">
/deep/.el-tabs__header{
margin-bottom: 0;
}
</style>
